// @core/api/endpoints/product/publish_product.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProductResponse,
  PublishProductRequest,
} from '../../../types/product';

const BASE_PATH = '/product';

/**
 * Publish product to catalog
 * Makes a product visible in the public catalog. Users can then discover and subscribe to the product.
 */
export async function PublishProduct(
  product_id: string,
  data: PublishProductRequest,
  options?: RequestOptions
): Promise<ProductResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:product_id/publish`;
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.post<ProductResponse>(requestPath, data, requestOptions);
}
